import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import ConfigurableTable from "app/components/AppComponents/ConfigurableTable";
import billerColumns from "./billerColumns";

type Props = {
  name: string;
} & PaginationProps;

const query = gql`
  query billers($offset: Int, $limit: Int) {
    billers(offset: $offset, limit: $limit) {
      id
      identifier
      provider
      name
      placeholder
      logo
      updated_at
      snapmin_url
    }
  }
`;

const withData = graphql<any, Props & PaginationProps>(query, {
  options: ({ pagination: { offset, limit } }) => ({
    fetchPolicy: "network-only",
    variables: {
      offset,
      limit
    }
  })
});

export default withPagination(
  withData(props => (
    <BOGraphQLLoader data={props.data}>
      <ConfigurableTable
        columnConfigs={billerColumns}
        defaultColumns={["Id", "Name", "Logo"]}
        rows={props.data.billers}
        pagination={props.pagination}
        name={props.name}
      />
    </BOGraphQLLoader>
  ))
);
